var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tab',{attrs:{"title":_vm.__('Onsend')}},[_c('Onsend')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }